import { z } from "zod";

export const STATSIG_SDK_KEY = import.meta.env.STATSIG_CLIENT_API_KEY;
export const STATSIG_ADS_MANAGER_DEDICATED_PROJECT_SDK_KEY = import.meta.env
  .STATSIG_ADS_MANAGER_DEDICATED_PROJECT_CLIENT_API_KEY;
export const ENVIRONMENT: "development" | "staging" | "prod" = import.meta.env.VITE_ENV;
z.enum(["development", "staging", "prod"]).parse(ENVIRONMENT); // parse separately to allow vite to statically resolve branches
export const APP_VERSION = import.meta.env.VITE_APP_RELEASE || "unknown";
export const PERSONA_ENVIRONMENT_ID =
  ENVIRONMENT === "prod" ? "env_WY4QSjrsR6hvWsWWawZjLkBkQcHS" : "env_x7wi9LLyKV2SFahfNJB2YNi1EKcg";

export const DEFAULT_LOCALE = "en-US";

export const PUBLIC_SOFA_BACKEND_URL: string = import.meta.env.PUBLIC_SOFA_BACKEND_URL;
export const OVERVIEW_TAB_GATE = "bazaar.tapestry.show_overview_tab";
export const CREATE_NEW_AD_ACCOUNT_GATE = "bazaar.tapestry.create_new_ad_account";
export const ASSET_LIBRARY_GATE = "bazaar.tapestry.asset_library";
export const MOBILE_WEB_ACCOUNT_SETUP_GATE = "bazaar.tapestry.mobile_web_account_setup";

export enum StatsigCustomId {
  DEVICE_ID = "device_id",
  AD_ACCOUNT_ID = "ad_account_id",
  ORG_ID = "org_id",
  STABLE_ID = "stableID",
}
